import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getSupportTickets(params = {}) {
  return axios.get('/ajax/support_tickets', { params })
}

export function getSupportTicket(id) {
  return axios.get(`/ajax/support_tickets/${id}`)
}

export function createSupportTicket(data) {
  const formData = new FormData()
  formData.append('website_id', data.websiteId)
  formData.append('subject', data.subject)
  formData.append('body', data.body)
  formData.append('category', data.category)
  if (data.priority) {
    formData.append('priority', data.priority)
  }
  if (data.attachments) {
    data.attachments.forEach((file) => {
      formData.append('attachments[]', file)
    })
  }
  return axios.post('/ajax/support_tickets', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function addTicketReply(ticketId, data) {
  const formData = new FormData()
  formData.append('body', data.body)
  if (data.attachments) {
    data.attachments.forEach((file) => {
      formData.append('attachments[]', file)
    })
  }
  return axios.post(`/ajax/support_tickets/${ticketId}/messages`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
